import { useNavigate, useParams, Link } from "react-router-dom";
import PageList from "../../templates/PageList";
import PageSearch from "../../molecules/PageSearch";
import { FaPlus, FaChevronDown, FaSync } from "react-icons/fa";
import { useState } from "react";

type Contract = {
    contract: {
        contract_built: {
            sequencial_number: number;
        };
        operation: {
            operation_type: string;
            operation_value: number;
            approved_value: number;
            base_rate: number;
            operation_rate: number;
            spread_rate: number;
            funding_rate: number;
            total_efective_cost: number;
            limit_rate: number;
            expiration_date: string;
        };
    };
    credit_operation_id: string;
};

const OperationsPage = () => {
    const navigate = useNavigate();
    const { page = '0', pageSize = '100', field: fieldSorted = 'id', order: orderSorted = 'ASC', filter = 's=;' }: any = useParams();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    let searchFilter = '';

    if (filter) {
        [searchFilter = ''] = filter.match(/=(.*?);/g)
            ?.map((match: string) => match.slice(1, -1)) || [''];
    }

    const REACT_APP_CONTRACTS_API_URL = process.env.REACT_APP_CONTRACTS_MANAGEMENT_API_URL;
    const REACT_APP_CONTRACTS_API_KEY = process.env.REACT_APP_CONTRACTS_MANAGEMENT_API_KEY;

    const url = `${REACT_APP_CONTRACTS_API_URL}/contracts/receivables_assignment/list?refresh=${refreshKey}`;
    const fetchHeaders = [{ key: 'x-api-key', value: REACT_APP_CONTRACTS_API_KEY || '' }];

    const formatOperationType = (type: string) => {
        switch (type) {
            case 'LOAN':
                return 'Empréstimo';
            case 'RECEIVABLES_ASSIGNMENT':
                return 'Cessão de recebíveis';
            case 'STRUCTURED_OPERATION':
                return 'Operação estruturada';
            case 'ACKNOWLEDGEMENT_DEBT':
                return 'Confissão de divida';
            default:
                return type || 'N/A';
        }
    };

    const formatWithRecourse = (withRecourse: boolean) => {
        return withRecourse ? 'Com regresso' : 'Sem regresso';
    };

    const renderRows = (data: any) => {
        console.log('Data received in renderRows:', data);

        let contracts = data;

        if (data && data.list) {
            contracts = data.list;
        }

        if (!contracts || !Array.isArray(contracts)) {
            console.log('No contracts array found');
            return [];
        }

        return contracts.map((item: any, index: number) => (
            <tr key={index} className={`${index % 2 === 0 ? 'bg-slate-100' : ''} hover:bg-slate-300 hover:shadow-md border-b border border-gray-300`}>
                <td className="py-2 px-2 whitespace-nowrap">{item.sequencial_number || 'N/A'}</td>
                <td className="py-2 px-2 whitespace-nowrap">{item.operation_number || 'N/A'}</td>
                <td className="py-2 px-2 whitespace-nowrap">{item.assignor || 'N/A'}</td>
                <td className="py-2 px-2 whitespace-nowrap">{formatOperationType(item.operation_type)}</td>
                <td className="py-2 px-2 whitespace-nowrap">R$ {(item.nominal_value || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                <td className="py-2 px-2 whitespace-nowrap">R$ {(item.approved_value || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                <td className="py-2 px-2 whitespace-nowrap">{formatWithRecourse(item.with_recourse)}</td>
                <td className="py-2 px-2 whitespace-nowrap">{item.due_date ? new Date(item.due_date).toLocaleDateString('pt-BR') : 'N/A'}</td>
                <td className="py-2 px-2 whitespace-nowrap">{item.created_at ? new Date(item.created_at).toLocaleDateString('pt-BR') : 'N/A'}</td>
                <td className="py-2 px-2 whitespace-nowrap">{item.approved_on ? new Date(item.approved_on).toLocaleDateString('pt-BR') : 'N/A'}</td>
                <td className="py-2 px-2 text-center whitespace-nowrap">
                    <button
                        onClick={() => {
                            switch (item.operation_type) {
                                case 'LOAN':
                                    navigate(`/operations/loan/${item.credit_operation_id || ''}`);
                                    break;
                                case 'RECEIVABLES_ASSIGNMENT':
                                    navigate(`/operations/receivables-assignment/${item.credit_operation_id || ''}`);
                                    break;
                                case 'STRUCTURED_OPERATION':
                                    navigate(`/operations/structured-operation/${item.credit_operation_id || ''}`);
                                    break;
                                case 'ACKNOWLEDGEMENT_DEBT':
                                    navigate(`/operations/acknowledgement-debt/${item.credit_operation_id || ''}`);
                                    break;
                                default:
                                    navigate(`/operations/receivables-assignment/${item.credit_operation_id || ''}`);
                                    break;
                            }
                        }}
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded text-sm whitespace-nowrap"
                    >
                        Gerenciar
                    </button>
                </td>
            </tr>
        ));
    };

    const pageChanged = (newPage: number) => {
        const adjustedPage = newPage - 1;
        navigate(`/operations/${adjustedPage}/${pageSize}/${fieldSorted}/${orderSorted}/s=${searchFilter};`, { replace: true });
    };

    const pageSorted = (field: string, order: 'ASC' | 'DESC') => {
        navigate(`/operations/${page}/${pageSize}/${field}/${order}/s=${searchFilter};`, { replace: true });
    };

    const pageSizeChanged = (newPageSize: number) => {
        navigate(`/operations/0/${newPageSize}/${fieldSorted}/${orderSorted}/s=${searchFilter};`, { replace: true });
    };

    const onSearch = (value: string) => {
        navigate(`/operations/0/${pageSize}/${fieldSorted}/${orderSorted}/s=${value};`, { replace: true });
    };

    const onFilterClean = () => {
        navigate(`/operations/0/${pageSize}/${fieldSorted}/${orderSorted}/s=;`, { replace: true });
    };

    const handleRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const tableHeaders = [
        { id: 'sequencial_number', title: 'Código Contrato', canSort: true, field: 'sequencial_number' },
        { id: 'operation_number', title: 'Código Operação', canSort: true, field: 'operation_number' },
        { id: 'assignor', title: 'Cedente', canSort: true, field: 'assignor' },
        { id: 'operation_type', title: 'Tipo Operação', canSort: true, field: 'operation_type' },
        { id: 'nominal_value', title: 'Valor Nominal', canSort: true, field: 'nominal_value' },
        { id: 'approved_value', title: 'Valor Aprovado', canSort: true, field: 'approved_value' },
        { id: 'with_recourse', title: 'Regresso', canSort: true, field: 'with_recourse' },
        { id: 'due_date', title: 'Data Vencimento', canSort: true, field: 'due_date' },
        { id: 'created_at', title: 'Data Criação', canSort: true, field: 'created_at' },
        { id: 'approved_on', title: 'Data Aprovação', canSort: true, field: 'approved_on' },
        { id: 'actions', title: 'Ações', canSort: false }
    ];

    return (
        <PageList
            pageTitle="Lista de Contratos"
            url={url}
            fetchHeaders={fetchHeaders}
            breadcrumb={[{ label: 'Contratos', url: "#" }]}
            tableHeaders={tableHeaders}
            defaultBackendHeader={false}
            tableFieldSort={fieldSorted}
            tableOrderSort={orderSorted}
            onTableSort={pageSorted}
            renderRows={renderRows}
            page={parseInt(page) || 0}
            pageSize={parseInt(pageSize) || 100}
            onPageChange={pageChanged}
            onItemsPerPageChange={pageSizeChanged}
            itemsLabel="contratos"
            onGotApiPayload={(data) => console.log('API Payload:', data)}
        >
            {{
                filterSlot: (
                    <PageSearch
                        value={searchFilter}
                        label="Procurar contratos..."
                        onSearch={onSearch}
                        filterCleanVisible={true}
                        filterCleanEnabled={!!searchFilter}
                        configureVisible={false}
                        onFilterClean={onFilterClean}
                    />
                ),
                controlSlot: (
                    <div className='pt-4 relative'>
                        <button
                            type='button'
                            onClick={handleRefresh}
                            className='text-white bg-gradient-to-r from-gray-500 via-gray-600 to-gray-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded text-sm px-5 py-2.5 text-center mr-2 mb-2'
                            title="Recarregar tabela"
                        >
                            <FaSync />
                        </button>
                        <button
                            type='button'
                            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                            className='text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded text-sm px-5 py-2.5 text-center mr-2 mb-2'
                        >
                            <div className="flex items-center">
                                <FaPlus className='mr-2' />
                                <span>Nova Operação</span>
                                <FaChevronDown className='ml-2' />
                            </div>
                        </button>
                        {isDropdownOpen && (
                            <div className="absolute top-full right-0 mt-1 bg-white dark:bg-slate-700 border border-gray-300 dark:border-gray-600 rounded shadow-lg z-50 min-w-max">
                                <Link
                                    to={`/contracts/loan/new`}
                                    onClick={() => setIsDropdownOpen(false)}
                                    className="block px-4 py-2 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-slate-600 rounded-t whitespace-nowrap"
                                >
                                    Empréstimo
                                </Link>
                                <Link
                                    to={`/contracts/new?operation_type=STRUCTURED_OPERATION`}
                                    onClick={() => setIsDropdownOpen(false)}
                                    className="block px-4 py-2 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-slate-600 rounded-b whitespace-nowrap"
                                >
                                    CPRF estruturada
                                </Link>

                                <Link
                                    to={`/contracts/new?operation_type=RECEIVABLES_ASSIGNMENT`}
                                    onClick={() => setIsDropdownOpen(false)}
                                    className="block px-4 py-2 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-slate-600 rounded-b whitespace-nowrap"
                                >
                                    Cessão de recebíveis
                                </Link>

                                <Link
                                    to={`/contracts/new?operation_type=ACKNOWLEDGEMENT_DEBT`}
                                    onClick={() => setIsDropdownOpen(false)}
                                    className="block px-4 py-2 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-slate-600 rounded-b whitespace-nowrap"
                                >
                                    Confissão de divídas
                                </Link>
                            </div>
                        )}
                    </div>
                )
            }}
        </PageList>
    );
};

export default OperationsPage;